export interface Constants {
    headerHeight: number;
    borderRadius: number;
    minScreenWidth: number;
}

declare module "@mui/material/styles/createTheme" {
    interface Theme {
        constants?: Constants;
    }
    interface ThemeOptions {
        constants?: Constants;
    }
}

export const constants: Constants = {
    headerHeight: 61,
    borderRadius: 4,
    minScreenWidth: 1280,
};
